import styled from 'styled-components';

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

export const Container = styled.div`
    background-color: #FFFFFF;
    border-radius: 16px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const Content = styled.div`
    padding: 32px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const IconWrapper = styled.div`
    width: 48px;
    height: 48px;
    margin-bottom: 20px;
    
    img {
        width: 100%;
        height: 100%;
    }
`;

export const Title = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #303030;
    margin: 0 0 12px 0;
`;

export const Description = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #696969;
    line-height: 1.5;
    margin: 0 0 28px 0;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
`;

export const OutlineButton = styled.button`
    flex: 1;
    padding: 12px 24px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0090D3;
    background-color: transparent;
    border: 1px solid #0090D3;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #E8F5FA;
    }
`;

export const PrimaryButton = styled.button`
    flex: 1;
    padding: 12px 24px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
    background-color: #0090D3;
    border: none;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #007AB8;
    }
`;
